module.exports = __webpack_public_path__ + "img/cloud-bg.4fee355a.png";